import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'components/Modal';

import globe_with_meridians from 'assets/emoji/globe_with_meridians.webp';

import { ButtonText, Container, Emoji, StyledButton, Subtitle, Title } from './styles';

const NoConnectionModal = () => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);

    const onClick = () => {
        setIsLoading(true);

        setTimeout(() => {
            setIsLoading(false);
        }, 3000);
    };

    return (
        <Modal
            isOpen
            customStyles={{
                padding: 'unset',
            }}
            dataLocator="noConnectionModal"
        >
            <Container>
                <Emoji $center alt={t('basics.noInternet.title')} src={globe_with_meridians} disableLazyLoad />
                <Title bold center>
                    {t('basics.noInternet.title')}
                </Title>
                <Subtitle $mb center>
                    {t('basics.noInternet.subTitle')}
                </Subtitle>
                <StyledButton isLoading={isLoading} dataLocator="noConnectionModalBtn" onClick={onClick}>
                    <ButtonText as="span">{t('basics.tryAgain')}</ButtonText>
                </StyledButton>
            </Container>
        </Modal>
    );
};

export default NoConnectionModal;
